/*eslint-disable*/
import * as Styled from './styles';

export const DensityLayerItem = ({
  layerId,
  label,
  swatchStyle,
  swatchType = 'circle',
  hasLabels = false,
  subpanel = null,
  stackingOrder,
  isActive = false,
  isLabelsActive = false,
  onToggle = () => {},
  onLabelsToggle = () => {},
  inputType = 'checkbox-item',
  type = 'checkbox',
  children,
}) => {
  return (
    <div className="leaflet-biglayerpanel-layer" data-layer-id={layerId} data-layer-stacking={stackingOrder}>
      <div className="leaflet-biglayerpanel-layer-left">
        <Styled.HeaderSelectionWrapper>
          <div className={inputType}>
            <input
              type={type}
              name={layerId}
              value={layerId}
              id={`leaflet-biglayerpanel-layer-${layerId}`}
              checked={isActive}
              onChange={(e) => onToggle(layerId, e.target.checked)}
            />
            <label tabIndex="0" htmlFor={`leaflet-biglayerpanel-layer-${layerId}`}>
              {swatchStyle && (
                <div
                  className={`leaflet-biglayerpanel-layer-swatch leaflet-biglayerpanel-layer-swatch-${swatchType}`}
                  style={swatchStyle}
                ></div>
              )}
              {label}
            </label>
          </div>
          {children}
        </Styled.HeaderSelectionWrapper>

        {subpanel && <div className="leaflet-biglayerpanel-layer-subpanel">{subpanel}</div>}
      </div>

      {hasLabels && (
        <div className="leaflet-biglayerpanel-layer-right">
          <div className="checkbox-item">
            <input
              type="checkbox"
              name="overlays"
              value={`${layerId}-labels`}
              id={`leaflet-biglayerpanel-layer-${layerId}-labels`}
              checked={isLabelsActive}
              onChange={(e) => onLabelsToggle(`${layerId}-labels`, e.target.checked)}
            />
            <label tabIndex="0" htmlFor={`leaflet-biglayerpanel-layer-${layerId}-labels`}>
              Labels
            </label>
          </div>
        </div>
      )}
    </div>
  );
};
